// src/utils/fetchUser.js
import React from 'react';
import { apiFetch } from './fetchApi';


export const fetchUser = ({ BeURL, setUser, setSpocOption, setClinentOption, showAlert }) => {
    apiFetch(`${BeURL}/fetch-user`, {
        method: 'GET',
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                setUser(data.users);
                setSpocOption(data.spocs)
                setClinentOption(data.client)
            } else {
                showAlert(data.message)
            }
        })
        .catch((err) => {
            console.log("Error in fetch user", err);
        });
};


